import React, { useEffect, useState } from "react";
// Added by Jaseem 11-2-2026
import { DataGrid } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
//=====================================================

import { getUserDetails } from "../../utils/helper";

import {
  Button,
  Col,
  Container,
  Row,
  Stack,
  Breadcrumb,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import solisPowerApi from "../../api/solisPowerApi";
import ".././../assets/css/ListComponentsTable.css";
import { ROUTES } from "../../constants/webRouting";
import InfoPill from "../InfoPill";
import PERMISSIONS from "../../constants/permissions";

const CommissionList = () => {
  const userInfo = getUserDetails();
  const navigate = useNavigate();
  const [body, setBody] = useState([]);

  //Added By Jaseem 11-02-2026
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState(rows);
  const [searchText, setSearchText] = useState("");
  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = rows.filter((row) =>
      Object.values(row).some(
        (field) =>
          field && field.toString().toLowerCase().includes(value.toLowerCase()),
      ),
    );

    setFilteredRows(filtered);
  };
  useEffect(() => {
    async function init() {
      const result = await solisPowerApi.fetchCommissions();
      if (result && Array.isArray(result)) {
        setBody(result);
        const mappedRows = result.map((item, index) => ({
          id: item.id || index, // DataGrid ke liye mandatory
          firstname: item.firstname || "-",
          createddate: item.createddate || "-",
          amount: item.amount || "-",
          lead_name: item.lead_name || "-",
          contact_name: item.contact_name || "-",
          project_name: item.project_name || "-",
        }));

        setRows(mappedRows);
        setFilteredRows(mappedRows);
      } else {
        setBody([]);
      }
    }
    init();
  }, []);

  const columns = [
    {
      field: "contact_name",
      headerName: "Commission Agent Name",
      flex: 1,
      // renderCell: (params) => params.row.contact_name || "-",
      renderCell: (params) => {
        const row = params.row;

        return (
          <Link
            // to={"/leads/" + row.contact_id}
            to={`${ROUTES.COMMISSION.VIEW.replace(":id", row.id)}`}
            state={row.id}
            style={{
              color: "#1a73e8",
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            {row.contact_name}
          </Link>
        );
      },
    },
    {
      field: "amount",
      headerName: "Commission  Amount",
      flex: 1,
      renderCell: (params) =>
        params.row.amount !== null && params.row.amount !== undefined
          ? `₹${parseFloat(params.row.amount).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
          : "-",
    },
    {
      field: "lead_name",
      headerName: "Lead Name",
      flex: 1,
      renderCell: (params) => params.row.lead_name || "-",
    },
    {
      field: "project_name",
      headerName: "Project Name",
      flex: 1,
      renderCell: (params) => params.row.project_name || "-",
    },
  ];
  // ========================================= 11-02-2026 ==========================================
  const createCommission = () => {
    navigate(ROUTES.COMMISSION.CREATE);
  };

  return (
    <Container fluid>
      <Row className="align-items-end">
        <Breadcrumb>
          <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item onClick={() => navigate(ROUTES.COMMISSION.LIST)}>
            Commissions
          </Breadcrumb.Item>
        </Breadcrumb>
        {/* Added By Jaseem 11-02-2026 */}
        <Col lg={2} md={4} xl={2} sm={12} className="">
          <div className="leads-header">
            <div className="leads-actions">
              <TextField
                size="small"
                placeholder="Search Commissions..."
                className="custom-search-field"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          </div>
        </Col>
        {/* =================================================== */}
        <Col className="py-1">
          {/* <BrowserView> */}
          <div className="d-flex py-1 px-2">
            <InfoPill
              left="Total"
              right={body?.length || 0}
              rightClasses="bg-custom text-white border-white fw-bold"
              leftClasses="bg-white fw-bold"
            />
          </div>
          {/* </BrowserView> */}
        </Col>
        <Col
          xs={12}
          sm={6}
          lg={4}
          className="d-flex flex-col justify-content-end align-items-end"
        >
          <Stack direction="horizontal" gap={2}>
            {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_MAKE].some(
              (permission) => {
                return userInfo?.permissions
                  .map((p) => p.name)
                  .includes(permission);
              },
            ) && (
                <Button
                  size="sm"
                  className="btn-create"
                  onClick={() => createCommission(true)}
                >
                  New Commission
                </Button>
              )}
          </Stack>
        </Col>
      </Row>
      {/* Added By Jaseem 11-02-2026 */}
      <Row>
        <div className="leads-page">
          {/* Header */}

          {/* DataGrid */}
          <div
            style={{
              height: 400,
              width: "100%",
              marginTop: "20px",
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            }}
          >
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pageSize={25}
              rowsPerPageOptions={[25]}
              getRowHeight={() => "auto"}
              disableRowSelectionOnClick
              className="custom-datagrid"
              sx={{
                border: "none",
                "& .MuiDataGrid-virtualScroller": {
                  overflowX: "hidden",
                },
              }}
            />
          </div>
        </div>
      </Row>
      {/* ==========================End By Jaseem ============================================= */}
    </Container>
  );
};

export default CommissionList;
